<template>
  <div class="mb10" style="padding-top:10px">
    <div class="flex mb10 align-center">
      <p class="dialog-common-title">项目小结</p>
      <el-tooltip effect="dark" content="点击可将项目小结文字版复制到剪贴板，可微信直接发送给客户" placement="right">
        <span class="btn_default" @click="copy">复制文字</span>
      </el-tooltip>
    </div>
    <div class="input-box">
      <!-- <el-input v-if="summaryEditing" v-model="summary" class="flex-grow" type="textarea" size="mini" :rows="6" placeholder="">
      </el-input> -->
      <div v-if="summaryEditing" class="project-summary">
        <div class="flex mb10">
          <div class="half">
            <p class="flex">
              <span class="keep-all dialog-common-title w196">符合要求人选（人数）：</span>
              <!-- {{ radishProjectDetail.已搜寻 }} -->
              <el-input v-model="countDetail.已搜寻" class="mr10" style="width:60px" size="mini"></el-input>
            </p>
          </div>
          <div class="half">
            <p class="flex">
              <span class="keep-all dialog-common-title">已推荐人选（人数）：</span>
              <!-- {{ radishProjectDetail.已沟通 }} -->
              <el-input v-model="countDetail.已推荐" class="mr10" style="width:60px" size="mini"></el-input>
            </p>
          </div>
        </div>
        <div class="flex mb10">
          <span class="keep-all dialog-common-title w196">搜索行业：</span>
          <el-input v-model="countDetail.行业" class="flex-grow" size="mini"></el-input>
          <!-- <div class="flex-grow" style="padding-top:2px">{{ (radishProjectDetail.行业 || []).join('、') }}</div> -->
        </div>
        <div class="flex mb10">
          <span class="keep-all dialog-common-title w196">搜索公司：</span>
          <el-input v-model="countDetail.公司" class="flex-grow" size="mini"></el-input>
          <!-- <div class="flex-grow" style="padding-top:2px">{{ (radishProjectDetail.公司 || []).join('、') }}</div> -->
        </div>
        <div class="flex mb10">
          <span class="keep-all dialog-common-title w196">重点推荐：</span>
          <el-input v-model="countDetail.重点推荐" class="flex-grow" size="mini"></el-input>
        </div>
        <div class="textarea-btn-box">
          <el-button class="mr10" type="primary" size="mini" plain @click="saveSummarize">保存</el-button>
          <el-button type="primary" size="mini" plain @click="summaryEditing = false">取消</el-button>
        </div>
      </div>
      <div v-else class="project-summary">
        <!-- <pre>{{project.项目小结||summary}}</pre>
        <span class="project-summary-btn" @click="toEditSummary">编辑</span> -->
        <span class="project-summary-btn" @click="toEdit">编辑</span>
        <div class="flex mb10">
          <div class="half">
            <p class="flex align-center">
              <span class="keep-all w155">符合要求人选（人数）：</span>
              <span style="line-height: 24px;">{{
                (project.项目小结详情 && project.项目小结详情.已搜寻) || radishProjectDetail.已搜寻
              }}</span>
            </p>
          </div>
          <div class="half">
            <p class="flex align-center">
              <span class="keep-all w155 flex-none">已推荐人选（人数）：</span>
              <span style="line-height: 24px;">{{
                (project.项目小结详情 && project.项目小结详情.已推荐) || radishProjectDetail.已推荐
              }}</span>
            </p>
          </div>
        </div>
        <div class="flex mb10">
          <span class="keep-all w155">搜索行业：</span>
          <span style="line-height: 24px;">{{
            (project.项目小结详情 && project.项目小结详情.行业) || (radishProjectDetail.行业 || []).join('、')
          }}</span>
        </div>
        <div class="flex mb10">
          <span class="keep-all w155">搜索公司：</span>
          <span style="line-height: 24px;">{{
            (project.项目小结详情 && project.项目小结详情.公司) || (radishProjectDetail.公司 || []).join('、')
          }}</span>
        </div>
        <div class="flex mb10">
          <span class="keep-all w155">重点推荐：</span>
          <p class="word-wrap" style="line-height: 24px;">
            {{ project.项目小结详情 && project.项目小结详情.重点推荐 }}
          </p>
        </div>
      </div>
    </div>

    <p class="dialog-common-title mb10">可以生成一份更详细的市场报告，更有力推动客户</p>
    <el-popover placement="right" width="800" trigger="click">
      <div>
        <p>
          请点击勾选O，选择你要使用的项目报告类型：<peixun
            type="10"
            style="display:inline-block;margin-left:5px;position:relative;top:3px;"
          ></peixun>
        </p>
        <div class="flex-row">
          <div class="col-1 pd10" @click="reportType = 'mapping'">
            <el-radio v-model="reportType" label="mapping">人选mapping报告</el-radio>
            <p class="ft-gray">自行选择需要的人选字段，并形成报告。</p>
            <div><img src="../../../../assets/images/project_mapping.png" class="img_max" /></div>
          </div>
          <div class="col-1 pd10" @click="reportType = 'report'">
            <el-radio v-model="reportType" label="report">搜索进度报告</el-radio>
            <p class="ft-gray">根据项目推进情况，自动进行统计，形成进度报告。</p>
            <div><img src="../../../../assets/images/project_report.png" class="img_max" /></div>
          </div>
        </div>
        <div class="text_right">
          <!-- <a :href="`#/project/${project.pid || project._id}/${reportType}`" class="btn_default" target="_blank"
            >生成报告</a
          > -->
          <span class="btn_default" @click="getReport">生成报告</span>
        </div>
      </div>
      <!-- <div slot="reference" class="item">生成项目报告</div> -->
      <el-button slot="reference" type="primary" size="mini">生成详细市场报告</el-button>
      <!-- <div slot="reference" class="project-btn" style="height:100%">生成报告</div> -->
    </el-popover>

    <p style="margin:10px 0">给客户经理的反馈</p>
    <div
      v-for="(item, index) in project.项目小结给客户经理反馈"
      :key="`feedback2manager${index}`"
      :class="item && item.user === user ? 'remark-self' : ''"
    >
      <span v-if="item.badge" class="badge-dot"></span>
      <span class="remark-date">
        {{ dateFormat(item.createdAt, 'yyyy-mm-dd') }}
        <span class="remark-time">{{ dateFormat(item.createdAt, 'HH:MM') }}</span> -- {{ item.user }}
      </span>
      <span style="padding-left: 10px;"> {{ item.content }}</span>
    </div>
    <el-input
      v-model="feedback2manager"
      class="flex-grow"
      type="textarea"
      size="mini"
      :rows="3"
      placeholder="从市场上了解的项目情况、其他竞争对手的情况，需要客户经理去确认的问题等，填写此处微信会自动发送给客户经理；"
    >
    </el-input>

    <p style="margin:10px 0">客户经理给项目的反馈</p>
    <div
      v-for="(item, index) in project.项目小结给项目反馈"
      :key="`feedback2project${index}`"
      :class="item && item.user === user ? 'remark-self' : ''"
    >
      <span v-if="item.badge" class="badge-dot"></span>
      <span class="remark-date">
        {{ dateFormat(item.createdAt, 'yyyy-mm-dd') }}
        <span class="remark-time">{{ dateFormat(item.createdAt, 'HH:MM') }}</span> -- {{ item.user }}
      </span>
      <span style="padding-left: 10px;"> {{ item.content }}</span>
    </div>
    <el-input
      v-model="feedback2project"
      class="flex-grow"
      type="textarea"
      size="mini"
      :rows="3"
      placeholder="从市场上了解的项目情况、其他竞争对手的情况，需要客户经理去确认的问题等，填写此处微信会自动发送给客户经理；"
    >
    </el-input>

    <div class="textarea-btn-box">
      <el-button type="primary" size="mini" plain @click="saveProjectFeedBack">保存</el-button>
    </div>
  </div>
</template>
<script>
import project_notify from '../../../../radish/src/constant/project_notify'

const dateFormat = require('dateformat')

export default {
  props: {
    project: { type: Object, default: () => ({}) },
    step: { type: String, default: '' },
  },
  data() {
    return {
      result: '',
      summaryEditing: false,
      summary: '',
      temp: {},
      reportType: 'mapping',
      countDetail: {},
      radishProjectDetail: {},
      feedback2manager: '',
      feedback2project: '',
      user: {},
    }
  },
  computed: {
    isCustomerManager() {
      const manger = this.project.客户开发 || []
      return manger.includes(app.user.account)
    },
  },
  watch: {
    project: {
      async handler(newValue, oldValue) {
        if (newValue._id !== (oldValue && oldValue._id)) {
          this.summaryEditing = false
        }
        this.countRadishes()
        // if (!newValue.项目小结) {
        //   this.getSummary()
        //   //           const str = `***，您好！

        //   // 针对（${newValue.项目名称}）职位，从（${dateFormat(newValue.createdAt, 'yyyy-mm-dd')}）至今，我们搜索（${(
        //   //             this.radishProjectDetail.公司 || []
        //   //           ).join('、')}）等公司人选，共计（${this.radishProjectDetail.已搜寻}）人，共推荐（${
        //   //             this.radishProjectDetail.已推荐
        //   //           }）人，暂时还未收到面试安排，不知领导反馈如何？期待您的反馈，我们好基于您的反馈，进一步精准搜素，或者维护现有人选，以防人选意向发生变化。在现有推荐人选中，我们重点推荐：（           ），建议尽快给与面试机会。感谢！您的每一次指导和支持，都让我们进步和提供更好的服务！`
        //   //           this.$set(newValue, '项目小结', str)
        // } else this.summary = newValue.项目小结
        // this.summaryEditing = false
      },
      immediate: true,
    },
  },
  mounted() {
    this.user = app.user
  },
  methods: {
    async getReport() {
      const { project } = this
      if (this.reportType === 'report') {
        const loading = this.$loading({
          lock: true,
          text: '正在获取项目进展报告，请稍等...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)',
        })
        try {
          const res = await app.service('project').getProjectReport({
            pid: project.pid || project._id,
          })
          if (res && res.status === 'success' && res.data) {
            app.root.$refs.ProjectReportEditor.open({
              url: res.data.url,
              md5: res.data.md5,
              documentType: res.data && res.data.documentType,
              fileType: res.data && res.data.fileType,
              originalname: res.data && res.data.originalname,
            })
          } else this.$message.error(res.msg)
        } catch (e) {
          console.error(e)
          this.$message.error(`生成项目搜索进度报告出错`)
        }
        loading.close()
      } else {
        app.root.$refs.MappingReportChooseHeaderDialog.open(project.pid || project._id)
      }
    },
    openTrainingVideo() {
      app.root.$refs.TrainingVideoDialog.open('mapping')
    },
    copy() {
      const oTextarea = document.createElement('textarea')
      const { project, radishProjectDetail } = this
      oTextarea.value = `    针对（${project.项目名称}）职位，从（${dateFormat(
        project.startTime || project.createdAt,
        'yyyy-mm-dd',
      )}）项目成立至今

    我们搜索了${(project.项目小结详情 && project.项目小结详情.行业) ||
      (radishProjectDetail.行业 || []).join('、')}等行业，共计${(project.项目小结详情 && project.项目小结详情.已搜寻) ||
        (radishProjectDetail.已搜寻 || 0)}人。

    共推荐${(project.项目小结详情 && project.项目小结详情.已推荐) ||
      (radishProjectDetail.已推荐 || 0)}人，暂时还未收到面试安排，不知领导反馈如何？

    期待您的反馈，我们好基于您的反馈，进一步精准搜素，或者维护现有人选，以防人选意向发生变化。

    在现有推荐人选中，我们重点推荐：（${(project.项目小结详情 && project.项目小结详情.重点推荐) || ''}），

    建议尽快给与面试机会。感谢！您的每一次指导和支持，都让我们进步和提供更好的服务！

    我们搜索的公司：${(project.项目小结详情 && project.项目小结详情.公司) ||
      (radishProjectDetail.公司 || []).join('、')}`
      document.body.appendChild(oTextarea)
      oTextarea.select()
      document.execCommand('Copy')
      document.body.removeChild(oTextarea)
      this.$message.success('复制成功')
    },
    async getSummary() {
      await this.countRadishes()
      const { project, radishProjectDetail } = this
      const str = `    针对（${project.项目名称}）职位，从（${dateFormat(
        project.startTime || project.createdAt,
        'yyyy-mm-dd',
      )}）项目成立至今

    我们搜索了${(radishProjectDetail.行业 || []).join('、')}等行业，共计${(radishProjectDetail.公司 || []).length}人。

    共推荐${(project.recommends && project.recommends.length) || 0}人，暂时还未收到面试安排，不知领导反馈如何？

    期待您的反馈，我们好基于您的反馈，进一步精准搜素，或者维护现有人选，以防人选意向发生变化。

    在现有推荐人选中，我们重点推荐：（           ），

    建议尽快给与面试机会。感谢！您的每一次指导和支持，都让我们进步和提供更好的服务！

    我们搜索的公司：${(radishProjectDetail.公司 || []).join('、')}`
      this.summary = str
      // this.$set(this.project, '项目小结', str)
    },
    // toEditSummary() {
    //   this.summaryEditing = true
    //   this.getSummary()
    // },
    toEdit() {
      this.summaryEditing = true
      this.countDetail = {
        已搜寻: this.radishProjectDetail.已搜寻,
        已推荐: this.radishProjectDetail.已推荐,
        行业: this.radishProjectDetail.行业.join('、'),
        公司: this.radishProjectDetail.公司.join('、'),
        重点推荐: this.radishProjectDetail.重点推荐.join('、'),
      }
      // this.getSummary()
    },
    async saveSummarize() {
      const param = { 项目小结详情: this.countDetail }
      await this.updateProject(param)
      this.summaryEditing = false
      project_notify.sendMessage3(this.project._id, '-项目小结', '项目小结', { 内容: this.summary }, '客户经理')
    },
    saveProjectFeedBack() {
      const { feedback2manager, feedback2project } = this
      const params = {}
      if (feedback2manager) {
        params['项目小结给客户经理反馈'] = this.project['项目小结给客户经理反馈'] || []
        params['项目小结给客户经理反馈'].push({
          user: app.user.account,
          content: feedback2manager,
          createdAt: new Date().getTime(),
        })
        this.feedback2manager = ''
      }
      if (feedback2project) {
        params['项目小结给项目反馈'] = this.project['项目小结给项目反馈'] || []
        params['项目小结给项目反馈'].push({
          user: app.user.account,
          content: feedback2project,
          createdAt: new Date().getTime(),
        })
        this.feedback2project = ''
      }

      if (Object.keys(params).length > 0) {
        this.updateProject(params)
        const notifyObj = {}
        notifyObj['项目小结给客户经理反馈'] = feedback2manager || ''
        notifyObj['项目小结给项目反馈'] = feedback2project || ''

        project_notify.sendMessage3(this.project._id, '-项目小结', '项目阶段反馈', notifyObj)
      }
      // const param = {
      //   项目小结给客户经理反馈: this.project.项目小结给客户经理反馈,
      //   项目小结给项目反馈: this.project.项目小结给项目反馈,
      // }
      // this.updateProject(param)
      // project_notify.sendMessage3(this.project._id, '-项目小结', '项目阶段反馈', {
      //   给客户经理的反馈: this.project.项目小结给客户经理反馈,
      //   客户经理给项目的反馈: this.project.项目小结给项目反馈,
      // })
    },
    async updateProject(param) {
      if (!this.project._id) return
      try {
        await window.app.service('project').modify({
          id: this.project._id,
          param,
        })
        Object.keys(param).forEach(field => {
          this.$set(this.project, field, param[field])
        })
        // Object.assign(this.project, param)
        this.$message({ type: 'success', message: `修改成功` })
      } catch (e) {
        this.$message.error(`update project :${e.message}`)
      }
    },
    async countRadishes() {
      console.log('countRadishes')
      const searchRadishDetail = {}
      const radishProject = this.project.radish_project || []
      const interviews = this.project.interviews || []

      searchRadishDetail.已搜寻 = radishProject.length
      const haveContacted = radishProject.filter(v => v.意向)
      searchRadishDetail.已沟通 = haveContacted.length
      const out = radishProject.filter(v => v.状态 && v.状态.detail === '淘汰')
      searchRadishDetail.已推荐 = (this.project.recommends || []).length
      searchRadishDetail.已淘汰 = out.length

      const interviewRids = interviews.map(val => val.rid)
      const setObj = new Set(interviewRids)
      searchRadishDetail.面试人数 = [...setObj].length

      const res = await app.service('radish').findByIds({ ids: radishProject.map(item => item.rid) })
      if (res.status === 'success') {
        const radishes = res.data
        searchRadishDetail.行业 = radishes.map(val => val.行业).filter(val => val)
        searchRadishDetail.公司 = radishes.map(val => val.公司).filter(val => val)
        const zhongdian = (this.project.recommends || []).filter(a => a.推荐度 === '重点推荐')
        searchRadishDetail.重点推荐 = zhongdian.map(a => {
          const rad = radishes.find(b => b._id === a.rid)
          return rad.姓名
        })
      } else this.$message.error(res.msg)
      const setObjIndustry = new Set(searchRadishDetail.行业)
      const setObjCompany = new Set(searchRadishDetail.公司)
      searchRadishDetail.行业 = [...setObjIndustry]
      searchRadishDetail.公司 = [...setObjCompany]
      this.radishProjectDetail = searchRadishDetail
    },
    dateFormat(time, format) {
      return dateFormat(time, format)
    },

    passed(date) {
      return date ? `${Math.ceil((Date.now() - date) / (24 * 3600 * 1000))}` : ''
    },
  },
}
</script>
<style scoped>
.bolder {
  font-weight: 700;
}
.bottom-line:after {
  content: '';
  display: block;
  width: 100%;
  height: 1px;
  background-color: #c5c5c5;
  margin-top: 5px;
  margin-bottom: 10px;
}
.textarea-btn-box {
  display: flex;
  justify-content: flex-end;
  padding-top: 10px;
}
.dialog-common-title {
  font-size: 16px;
  font-weight: 700;
  position: relative;
  text-indent: 20px;
  height: 24px;
}
.dialog-common-title:before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 5px;
  background-color: #409eff;
  display: block;
}
.project-summary {
  position: relative;
  border: 1px solid #eee;
  border-radius: 4px;
  padding: 10px 20px;
  line-height: 20px;
  margin: 10px;
  box-shadow: 1px 0px 8px 0 rgba(213, 215, 220, 0.6), 0 2px 4px 0 rgba(201, 203, 211, 0.5);
}
.project-summary-btn {
  position: absolute;
  top: 10px;
  right: 30px;
  color: #409eff;
  cursor: pointer;
  user-select: none;
}
.project-summary pre {
  white-space: pre-wrap;
  margin: 0;
}
.flex {
  display: flex;
}
.half {
  width: 50%;
}
.keep-all {
  word-break: keep-all;
  white-space: nowrap;
}
.dialog-common-title {
  font-size: 16px;
  font-weight: 700;
  position: relative;
  text-indent: 20px;
  height: 24px;
  flex: none;
}
.dialog-common-title:before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 5px;
  background-color: #409eff;
  display: block;
}
.project-summary .dialog-common-title {
  font-size: 14px;
  font-weight: 700;
  position: relative;
  text-indent: 20px;
  height: 24px;
  flex: none;
}
.w196 {
  width: 196px;
}
.w155 {
  text-indent: 8px;
  /* position: relative; */
  font-size: 14px;
  width: 160px;
  flex: none;
  font-weight: 800;
  line-height: 24px;
}
.align-center {
  align-items: center;
}
</style>
